let orzWasUnlocked = false;

async function checkOneRupeeZone() {
  const zone = document.getElementById('one-rupee-zone');
  if (!zone) return;

  const cart = await fetch('/cart.js').then(r => r.json());
  const threshold = parseInt(zone.dataset.threshold);
  const maxItems = parseInt(zone.dataset.maxItems || '1');
  const subtitleEl = document.getElementById('orz-subtitle-text');
  const originalSubtitle = zone.dataset.originalSubtitle || (zone.dataset.originalSubtitle = subtitleEl.textContent);

  const zoneItemCount = cart.items
    .filter(i => i.properties && i.properties['_orz'] === 'true')
    .reduce((sum, i) => sum + i.quantity, 0);

  const unlocked = cart.total_price >= threshold;
  const limitReached = zoneItemCount >= maxItems;

  zone.classList.toggle('is-locked', !unlocked);

  if (!unlocked) {
    const remaining = ((threshold - cart.total_price) / 100).toFixed(0);
    subtitleEl.textContent = `Add ₹${remaining} more to unlock`;
  } else {
    subtitleEl.textContent = originalSubtitle;
  }

  zone.querySelectorAll('.orz-add-btn').forEach(btn => {
    btn.disabled = !unlocked || limitReached;
    if (!unlocked) {
      btn.textContent = 'Locked';
    } else if (limitReached) {
      btn.textContent = 'Limit reached';
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
    }
  });

  if (unlocked && !orzWasUnlocked) {
    showOrzCelebration();
  }
  orzWasUnlocked = unlocked;
}

function showOrzCelebration() {
  const banner = document.getElementById('orz-celebration');
  if (!banner) return;
  banner.classList.add('is-visible');
  setTimeout(() => {
    banner.classList.remove('is-visible');
  }, 2200);
}

// Our own zone buttons
document.addEventListener('click', async (e) => {
  if (!e.target.classList.contains('orz-add-btn') || e.target.disabled) return;
  const variantId = e.target.dataset.variantId;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1, properties: { '_orz': 'true' } }]
    })
  });

  document.dispatchEvent(new CustomEvent('cart:updated'));
});

// Catch ANY cart change anywhere on the site (existing add-to-cart buttons,
// quantity changes, remove buttons, etc.) by watching every fetch call.
(function () {
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0] instanceof Request ? args[0].url : args[0];
    const isCartCall = typeof url === 'string' && url.includes('/cart/');
    const result = originalFetch.apply(this, args);
    if (isCartCall) {
      result.then(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }).catch(() => {});
    }
    return result;
  };
})();

// Fallback: also poll every few seconds in case something updates the cart
// without going through fetch (e.g. a full page reload after add-to-cart)
setInterval(checkOneRupeeZone, 4000);

document.addEventListener('cart:updated', checkOneRupeeZone);
document.addEventListener('DOMContentLoaded', checkOneRupeeZone);
